import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} Night Bacon. All rights reserved.</p>
        <div className="footer-logo">
          <img src="/nbr.jpg" alt="Night Bacon Records" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
